import React from 'react';
import OfficebookingLogo from '../../assets/images/officebooking.svg'
import {Link} from "react-router-dom";

export default function ContentCard({ children, title, text }) {
    
    return (
        <div className="row justify-content-center">
            <div className="content-card card mt-sm-4 overflow-hidden">
                <div className="content-card__logo mb-lg-5 mb-2 d-flex justify-content-start">
                    {/* <Link to="/"><img src={OfficebookingLogo} /></Link> */}
                </div>
                <div className="card-body">
                    <h1 className="card-title mb-4"><b>{title}</b></h1>
                    <p className="card-text">{text}</p>
                    <div className="mt-5">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}